export async function parseHtmlToDomNodes(
  htmlString: string
): Promise<ChildNode[]> {
  if (typeof window === 'undefined') {
    // Server-side with jsdom
    const { JSDOM } = await import('jsdom') // Dynamically import jsdom
    const { window } = new JSDOM(htmlString)
    return Array.from(window.document.body.childNodes)
  }

  // Client-side with DOMParser
  const parser = new DOMParser()
  const doc = parser.parseFromString(htmlString, 'text/html')
  return Array.from(doc.body.childNodes)
}
